/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_My_TasksInputs */

const en_nav_my_tasks = /** @type {(inputs: Nav_My_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Tasks`)
};

const pt_br2_nav_my_tasks = /** @type {(inputs: Nav_My_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minhas Atividades`)
};

/**
* | output |
* | --- |
* | "My Tasks" |
*
* @param {Nav_My_TasksInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const nav_my_tasks = /** @type {((inputs?: Nav_My_TasksInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_My_TasksInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_my_tasks(inputs)
	return pt_br2_nav_my_tasks(inputs)
});